module.exports = __webpack_public_path__ + "img/5-3-chef.6cd4602b.jpg";